import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(theme => ({
  container: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor:"rgb(7, 71, 166)",
    position: "absolute",
    top: 0,
    left: 0,
    fontFamily: "'Rubik', sans-serif"
  },
  logotype: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(12),
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  logotypeText: {
    fontWeight: 500,
    color: "white",
    marginLeft: theme.spacing(2),
  },
  logotypeIcon: {
    width: 70,
    marginRight: theme.spacing(2),
  },
  paperRoot: {
    boxShadow: theme.customShadows.widgetDark,
    display: "flex",
    background:'#eaf5fd',
    flexDirection: "column",
    alignItems: "center",
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
    maxWidth: 404,
  },
  textRow: {
    //marginBottom: theme.spacing(10),
    textAlign: "center",
  },
  textDetail: {
    //marginBottom: theme.spacing(10),
    textAlign: "center",
    fontSize : 17,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    color : '#C0FFB3'
  },
  textSubDetail: {
    //marginBottom: theme.spacing(10),
    textAlign: "center",
    fontSize : 13,
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(1),
    color : 'white'
  },
  textVerifyEmail: {
    //marginBottom: theme.spacing(10),
    textAlign: "center",
    fontSize : 16,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    color : 'rgb(7, 71, 166)'
  },
  errorCode: {
    fontSize: 148,
    fontWeight: 600,
  },
  safetyText: {
    fontWeight: 300,
    color: theme.palette.text.hint,
  },
  backButton: {
    boxShadow: theme.customShadows.widget,
    textTransform: "none",
    fontSize: 16,
  },
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: '25ch',
    },
  },
  button: {
    margin: theme.spacing(1),
    background : '#F1FCFC',
    color:'#2C7873',
    borderRadius : '8px',
    fontWeight : 'bold'
  },
  large: {
    width: theme.spacing(25),
    height: theme.spacing(25),
  },
  logotypeImage: {
    width: 120,
    height:120,
    marginBottom: theme.spacing(3),
  }
}));
